import { render, staticRenderFns } from "./EnvioAulas.vue?vue&type=template&id=9975e73e&scoped=true"
import script from "./EnvioAulas.vue?vue&type=script&lang=js"
export * from "./EnvioAulas.vue?vue&type=script&lang=js"
import style0 from "./EnvioAulas.vue?vue&type=style&index=0&id=9975e73e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9975e73e",
  null
  
)

export default component.exports